import React, { Component } from 'react';
import { getK3Docs, setK3Docs } from '../../services/k3docService';
import {
  Card,
  Table,
  Button,
  Form,
  Modal,
  Row,
  Col,
  Toast,
  ToastContainer
} from 'react-bootstrap';
import { BsPencil, BsCheck2, BsX } from 'react-icons/bs';

class UIConfigList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      configs: [],
      selectedConfig: null,
      isEditing: false,
      showEditModal: false,
      showToast: false,
      toastMessage: '',
      toastType: 'success'
    };
  }

  componentDidMount() {
    this.fetchConfigs();
  }

  fetchConfigs = () => {
    getK3Docs({ type: 'ui_config' })
      .then(response => {
        const data = response.data.data.docs;
        this.setState({ configs: data });
      })
      .catch(error => {
        console.error('Error fetching configs:', error);
      });
  };

  handleEdit = (config) => {
    try {
      const content = JSON.parse(config.content);
      this.setState({
        selectedConfig: {
          ...config,
          content
        },
        isEditing: true,
        showEditModal: true
      });
    } catch (error) {
      console.error('Error parsing config content:', error);
    }
  };

  handleSave = async () => {
    try {
      const { selectedConfig } = this.state;
      const updatedConfig = {
        ...selectedConfig,
        content: JSON.stringify(selectedConfig.content)
      };

      await setK3Docs([updatedConfig]);
      this.setState({
        showEditModal: false,
        isEditing: false,
        showToast: true,
        toastMessage: 'Config updated successfully',
        toastType: 'success'
      });
      this.fetchConfigs();
    } catch (error) {
      console.error('Error saving config:', error);
      this.setState({
        showToast: true,
        toastMessage: 'Error saving config',
        toastType: 'danger'
      });
    }
  };

  handleContentChange = (field, value) => {
    this.setState(prevState => ({
      selectedConfig: {
        ...prevState.selectedConfig,
        content: {
          ...prevState.selectedConfig.content,
          [field]: value
        }
      }
    }));
  };

  handleOptionChange = (field, index, key, value) => {
    this.setState(prevState => {
      const newOptions = [...prevState.selectedConfig.content[field].options];
      newOptions[index] = {
        ...newOptions[index],
        [key]: value
      };
      return {
        selectedConfig: {
          ...prevState.selectedConfig,
          content: {
            ...prevState.selectedConfig.content,
            [field]: {
              ...prevState.selectedConfig.content[field],
              options: newOptions
            }
          }
        }
      };
    });
  };

  addOption = (field) => {
    this.setState(prevState => {
      const newOptions = [...prevState.selectedConfig.content[field].options, { value: '', label: '' }];
      return {
        selectedConfig: {
          ...prevState.selectedConfig,
          content: {
            ...prevState.selectedConfig.content,
            [field]: {
              ...prevState.selectedConfig.content[field],
              options: newOptions
            }
          }
        }
      };
    });
  };

  removeOption = (field, index) => {
    this.setState(prevState => {
      const newOptions = prevState.selectedConfig.content[field].options.filter((_, i) => i !== index);
      return {
        selectedConfig: {
          ...prevState.selectedConfig,
          content: {
            ...prevState.selectedConfig.content,
            [field]: {
              ...prevState.selectedConfig.content[field],
              options: newOptions
            }
          }
        }
      };
    });
  };

  moveOption = (field, index, direction) => {
    this.setState(prevState => {
      const options = [...prevState.selectedConfig.content[field].options];
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= options.length) return {};
      [options[index], options[newIndex]] = [options[newIndex], options[index]];
      return {
        selectedConfig: {
          ...prevState.selectedConfig,
          content: {
            ...prevState.selectedConfig.content,
            [field]: {
              ...prevState.selectedConfig.content[field],
              options
            }
          }
        }
      };
    });
  };

  renderEditModal = () => {
    const { selectedConfig, showEditModal } = this.state;
    if (!selectedConfig) return null;

    return (
      <Modal show={showEditModal} onHide={() => this.setState({ showEditModal: false })} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Edit {selectedConfig.doc_mid}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {Object.entries(selectedConfig.content).map(([field, config]) => (
              <Card key={field} className="mb-4">
                <Card.Header>
                  <Row className="align-items-center">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Field Name</Form.Label>
                        <Form.Control type="text" value={field} disabled />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Field Label</Form.Label>
                        <Form.Control
                          type="text"
                          value={config.label}
                          onChange={(e) => this.handleContentChange(field, { ...config, label: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Button
                        variant="outline-primary"
                        onClick={() => this.addOption(field)}
                        className="mt-4"
                      >
                        Add Option
                      </Button>
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body>
                  <Table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Label</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {config.options.map((option, index) => (
                        <tr key={index}>
                          <td>
                            <Form.Control
                              type="text"
                              value={option.value}
                              onChange={(e) => this.handleOptionChange(field, index, 'value', e.target.value)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="text"
                              value={option.label}
                              onChange={(e) => this.handleOptionChange(field, index, 'label', e.target.value)}
                            />
                          </td>
                          <td>
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              disabled={index === 0}
                              onClick={() => this.moveOption(field, index, -1)}
                              style={{ marginRight: 4 }}
                            >↑</Button>
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              disabled={index === config.options.length - 1}
                              onClick={() => this.moveOption(field, index, 1)}
                              style={{ marginRight: 4 }}
                            >↓</Button>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => this.removeOption(field, index)}
                            >
                              <BsX />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.setState({ showEditModal: false })}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSave}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { configs, showToast, toastMessage, toastType } = this.state;

    return (
      <div className="container-fluid p-4">
        <h1>UI Configurations</h1>
        <Row>
          {configs.map(config => (
            <Col md={6} key={config._id} className="mb-4">
              <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                  <h4>{config.doc_mid}</h4>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => this.handleEdit(config)}
                  >
                    <BsPencil className="me-1" /> Edit
                  </Button>
                </Card.Header>
                <Card.Body>
                  <Table>
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Label</th>
                        <th>Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(JSON.parse(config.content)).map(([field, config]) => (
                        <tr key={field}>
                          <td>{field}</td>
                          <td>{config.label}</td>
                          <td>{config.options.length} options</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {this.renderEditModal()}

        <ToastContainer position="top-end" className="p-3">
          <Toast
            show={showToast}
            onClose={() => this.setState({ showToast: false })}
            bg={toastType}
            delay={3000}
            autohide
          >
            <Toast.Header closeButton={false}>
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body className="text-white">
              {toastMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    );
  }
}

export default UIConfigList; 